export function initLightbox() {
    return [...document.querySelectorAll(".c-lightbox:not(.-initialized)")].map((el) => new ComponentLightbox(el));
}

class ComponentLightbox {
    constructor(el) {
        this.element = el;
        this.element.classList.add('-initialized');
        this.attachEventListeners();
    }

    attachEventListeners() {
        this.lightboxOpen = this.element.querySelectorAll('.c-lightbox__open');
        this.lightboxClose = this.element.querySelectorAll('.c-lightbox__close');

        this.handleOpenClick = this.openLightbox.bind(this);
        this.handleCloseClick = this.closeLightbox.bind(this);

        this.lightboxOpen.forEach(openButton => {
            openButton.addEventListener('click', this.handleOpenClick);
        });

        this.lightboxClose.forEach(closeButton => {
            closeButton.addEventListener('click', this.handleCloseClick);
        });
    }

    openLightbox() {
        this.element.classList.add('-active');
        document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
        this.element.classList.remove('-active');
        document.body.style.overflow = '';
    }

    destroy() {
        this.lightboxOpen.forEach(openButton => {
            openButton.removeEventListener('click', this.handleOpenClick);
        });

        this.lightboxClose.forEach(closeButton => {
            closeButton.removeEventListener('click', this.handleCloseClick);
        });

        this.element.classList.remove('-initialized');
    }
}
